 

import type { RouteObject } from 'react-router';
import { lazyRoute, lazyRouteWithProps } from '../utils/lazyRoute';

const arRoutes: RouteObject[] = [
  {
    path: 'AR',
    children: [
      { path: 'HomePage', lazy: lazyRoute(() => import('../../pages/Finance/Ar/Main/ArDashboard')) },

      // ===== Settings =====
      { path: 'Customers', lazy: lazyRoute(() => import('../../pages/Sales/SalesSettings/Customers/Index')) },
      {
        path: 'Customers/AddCustomers',
        lazy: lazyRoute(() => import('../../pages/Sales/SalesSettings/Customers/Add'))
      },
      // {
      //   path: 'Customers/:Id/UpdateCustomers',
      //   lazy: lazyRoute(() => import('../../pages/Sales/SalesSettings/Customers/Update'))
      // },
      {
        path: 'Customers/:id/BranchesCustomer',
        lazy: lazyRoute(() => import('../../pages/Sales/SalesSettings/Customers/Branches/Index'))
      },
      {
        path: 'Customers/:peopleId/PeopleLocations',
        lazy: lazyRoute(() => import('../../pages/Sales/SalesSettings/Customers/CustomersLocations/CustomersLocations'))
      },

      { path: 'PaymentTerms', lazy: lazyRoute(() => import('../../pages/Finance/Settings/PaymentTerms/Index')) },
      { path: 'Currencies', lazy: lazyRoute(() => import('../../pages/Finance/Settings/Currencies/Index')) },

      // Accounting Period (prop)
      {
        path: 'AccountingPeriod',
        lazy: lazyRouteWithProps(
          () => import('../../pages/Finance/Settings/AccountingPeriod/Index'),
          () => ({ customProp: 'Ar' as const })
        )
      },

      // ===== AR Transactions =====
      { path: 'ArTransactions', lazy: lazyRoute(() => import('../../pages/Finance/Ar/ArTransactions/Index')) },
      {
        path: 'ArTransactions/AddArTransactions',
        lazy: lazyRoute(() => import('../../pages/Finance/Ar/ArTransactions/AddArTransactions'))
      },
      {
        path: 'ArTransactions/:transactionId/UpdateArTransactions',
        lazy: lazyRoute(() => import('../../pages/Finance/Ar/ArTransactions/UpdateArTransactions'))
      },
      {
        path: 'CreateAccountArTransactions',
        lazy: lazyRoute(() => import('../../pages/Finance/Ar/ArTransactions/CreateAccount/ListArTransactions'))
      },

      // ===== AR Receipts =====
      { path: 'ArReceipts', lazy: lazyRoute(() => import('../../pages/Finance/Ar/ArReceipts/Index')) },
      { path: 'ArReceipts/AddArReceipts', lazy: lazyRoute(() => import('../../pages/Finance/Ar/ArReceipts/Add/Add')) },
      {
        path: 'ArReceipts/:receiptId/UpdateArReceipts',
        lazy: lazyRoute(() => import('../../pages/Finance/Ar/ArReceipts/Update/Update'))
      },
      {
        path: 'CreateAccountArReceipts',
        lazy: lazyRoute(() => import('../../pages/Finance/Ar/ArReceipts/CreateAccount/ListArReceipts'))
      },

      // ===== Reports =====
      { path: 'ArReports', lazy: lazyRoute(() => import('../../pages/Finance/Ar/ArReports/ArReports')) },
      {
        path: 'ArReports/:ReportId/ReportsBuilder',
        lazy: lazyRoute(
          () => import('../../pages/NTX/Reports/ReportsAllByModule/Reports/ReportsBuilder/ReportsBuilder')
        )
      },

      // ===== Dashboards =====
      { path: 'ArDashboards', lazy: lazyRoute(() => import('../../pages/Finance/Ar/ArDashboards/ArDashboards')) },
      {
        path: 'ArDashboards/:dashboardId/BuilderDashboard',
        lazy: lazyRoute(() => import('../../pages/NTX/DashboardManagament/BuilderDashboard/BuilderDashboard'))
      }
    ]
  }
];

export default arRoutes;
